import Vue from 'vue';
import _ from 'lodash';
import { format, isToday, isFuture, eachDayOfInterval, isWithinInterval } from 'date-fns';
import { nl } from 'date-fns/locale'

Vue.component('agenda-live-feed-component', {
    props: {
        allItems: {
            type: Array
        },
        pinnedItems: {
            type: Array
        },
    },
    data() {
        return {
            // Events
            allEvents: [],
            mergedEvents: [],
            events: [],

            // First amount of visible days
            numberEvents: 8, // How many events do you want to show
        }
    },

    mounted() {
        this.mergedEvents = _.unionBy(this.pinnedItems, this.allItems, 'url');

        // Events
        this.mergedEvents = this.mergedEvents.filter((event, i) => {
            event.title = event.title && event.title.length > 96 ? _.truncate(event.title, {'length': 86, 'separator': ' '}) : event.title;
            event.description = event.description && event.description.length > 96 ? _.truncate(event.description, {'length': 96, 'separator': ' '}) : event.description;
            // check if events are all in future or are ongoing (if eventEndDate is in future)
            const eventEndDateFuture = event.eventEndDate !== null ? isFuture(new Date(event.eventEndDate)) : false;

            if (eventEndDateFuture) {
                event.allDays = eachDayOfInterval({ start: new Date(event.eventStartDate), end: new Date(event.eventEndDate) });
            }

            return isToday(new Date(event.eventStartDate)) || isFuture(new Date(event.eventStartDate)) || eventEndDateFuture;
        });

        this.events = _.slice(this.mergedEvents, 0, this.numberEvents);

        this.updateTime();
        setInterval(this.updateTime, 60 * 1000); // 1 min.
        setInterval('location.reload(true)', 1 * 60 * 60000); // 1 hour: force page reload from disk.
    },

    watch: {
    },

    filters: {
        dayOfWeekFormatter: function (val) {
            return format(new Date(val), "EEEE", { locale: nl })
        },
        dayNumberFormatter: function (val) {
            return format(new Date(val), "dd", { locale: nl })
        },
        monthFormatter: function (val) {
            const formattedDate = format(new Date(val), "MMM", { locale: nl });
            const result = formattedDate.split('.').join("")
            return result
        },
        timeFormatter: function (val) {
            const result = format(new Date(val), "HH:mm", { locale: nl });
            return result
        },
        formatPrice: function (price) {
            if (!price) {
                return '';
            }

            if (typeof price === 'string' && (price.toLowerCase() === 'gratis')) {
                return price;
            }

            // Convert the price to a string, divide by 100, and format it to two decimal places
            let format = (price).toFixed(2).replace('.', ',');

            // If the formatted string ends with ',00', replace it with ',–'
            if (format.endsWith(',00')) {
                format = format.slice(0, -3) + ',–';
            }

            // Return the formatted price with the Euro symbol
            return `€ ${format}`;
        }
    },

    methods: {
        updateTime() {
            this.$el.querySelector(".live-feed__clock-date").innerHTML = format(new Date(), "dd MMMM", { locale: nl })
            this.$el.querySelector(".live-feed__clock-time").innerHTML = format(new Date(), "HH:mm", { locale: nl })
        }

    },

    beforeDestroy() {

    }
});
